import React from "react";
import { Col, Container, Row, Button, Card } from "react-bootstrap";
import UpperProgressBar from "../components/common-components/UpperProgressBar";
import RightSidebar from "../components/common-components/right_sidebar";
import stdnt from "../assets/images/student.png";
import schl from "../assets/images/school.png";
import hsptl from "../assets/images/hospital.png";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { GetPageTittle } from "../services/utils";
const SelectUser = () => {

    const now = GetPageTittle()
    const card = ["School", "Student", "Hospital"]
    const navigate = useNavigate()

    const navigateTopage = () => {
        now === "School" ? navigate('/school-info') : now === "Student" ?
            navigate('/student-info') :
            navigate('/hospital-info')
    }

    return (
        <div className="signup_pg">
            <Container fluid>
                <div className="signup_pg_wrap">
                    <Row className="justify-content-center align-items-start">
                        <Col md={6}>
                            <UpperProgressBar step={2} />
                            <div className="signup_form">
                                <div className="sign_hdng">
                                    <h2>Selected User type</h2>
                                </div>
                                <div className="optn_cards_div">
                                    {card && card.map((curr, index) => {
                                        return (
                                            <div
                                                key={index}
                                                // onClick={() => { SetPageTittle({ tittle: curr }) }}
                                                className={`sign_card ${curr === now && 'active'}`}
                                            >
                                                <Card className="mb-3">
                                                    <Card.Body className="d-flex align-items-center">
                                                        {curr === now &&
                                                            <div className="crd_icn">
                                                                <BsFillCheckCircleFill />
                                                            </div>
                                                        }
                                                        <Card.Img src={curr === "School" ? schl : curr === "Hospital" ? hsptl : stdnt} />
                                                        <Card.Title>
                                                            You are a {curr}.{" "}
                                                        </Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        )
                                    })}
                                </div>
                                <Button
                                    onClick={() => { navigateTopage() }}
                                    className="btn_theme w-100 mt-4"
                                    type="submit"
                                    variant=""
                                >
                                    Continue
                                </Button>
                            </div>
                        </Col>
                        <RightSidebar step={2} />
                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default SelectUser;
